import React from 'react';

/**
 * Chip de categoria/etiqueta. `count` opcional, `selected` para el estado activo.
 */
function Chip({ icon: Icon, label, count, selected = false, onClick, className = '' }) {
  const Wrapper = onClick ? 'button' : 'span';
  return (
    <Wrapper
      type={onClick ? 'button' : undefined}
      className={`sgc-chip ${selected ? 'sgc-chip--selected' : ''} ${className}`}
      onClick={onClick}
      aria-pressed={onClick ? selected : undefined}
    >
      {Icon && <Icon width={14} height={14} aria-hidden="true" />}
      <span>{label}</span>
      {count !== undefined && <span className="sgc-chip__count">{count}</span>}
    </Wrapper>
  );
}

export default Chip;
